var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
		title: `${_vm.textTooltip}`,
		customClass: 'custom-tooltip',
		interactive: false,
		placement: 'bottom'
	}),expression:"{\n\t\ttitle: `${textTooltip}`,\n\t\tcustomClass: 'custom-tooltip',\n\t\tinteractive: false,\n\t\tplacement: 'bottom'\n\t}",modifiers:{"hover":true}}],staticClass:"border-0",attrs:{"variant":_vm.variant,"to":_vm.to,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('b-icon',{attrs:{"icon":"trash","variant":"outline-danger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }